import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-card',
  templateUrl: './progress-card.component.html',
  styleUrls: ['./progress-card.component.scss']
})
export class ProgressCardComponent {
  @Input() title: string = 'Progresso';
  @Input() value: number = 0;
}
